import { connect } from "react-redux";
import { Dispatch } from "redux";
import * as actions from "../common/actions";
import Breadcrumbs from "../common/components/FDIC/Breadcrumbs";
import { initialAppState } from "../common/reducers/appState";
import { All } from "../interfaces";

export function mapStateToProps({ appState }: All) {
  return {
    currentApp: appState.app,
  };
}

export function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    resetState: (app: string) => {
      dispatch(actions.resetState((initialAppState as any)[app]));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Breadcrumbs);
